<template>
  <search-main v-bind="$attrs">
    <template #search-summary-heading>
      <slot name="search-summary-heading" />
    </template>

    <template #before-summary>
      <slot name="before-summary" />
    </template>

    <template #search-guides>
      <slot name="search-guides" />
    </template>

    <template #search-pagepart>
      <slot name="search-pagepart" />
    </template>

    <template #popular-locations>
      <slot name="popular-locations" />
    </template>

    <template #lower-pagepart>
      <slot name="lower-pagepart" />
    </template>

    <template #pagination-controls="{ paginationData, searchFilters }">
      <slot
        name="pagination-controls"
        :pagination-data="paginationData"
        :search-filters="searchFilters"
      />
    </template>
  </search-main>
</template>

<script setup>
import { isSearchUrlRoute } from '../isSearchUrlComponent'

const searchStore = useSearchStoreSetup(usePinia())
const route = useRoute()

if (isSearchUrlRoute(route)) {
  onServerPrefetch(async () => {
    await searchStore.s()
  })
}
</script>
